/* unplugin-vue-components disabled */import script from "./GeoAnalysis.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoAnalysis.vue?vue&type=script&lang=ts&setup=true"

import "./GeoAnalysis.vue?vue&type=style&index=0&id=12424788&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12424788"]])

export default __exports__